import { fetch, createRequest } from "./fetchRequest";

export default function (url: string, queryParams?: { [key: string]: string }) {

    const qp: string[] = [];

    if (queryParams) {
        Object.keys(queryParams).forEach(key => qp.push(`${encodeURIComponent(key)}=${encodeURIComponent(queryParams[key])}`));
    }

    const urlWithQp = qp.length > 0 ? url + '?' + qp.join('&') : url;

    const request = createRequest(urlWithQp, "GET");

    return fetch(request);
}